/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Place from '../../../utils/constants/place.constant';
export function EditMaterialForm({
  errors,
  material,
  Controller,
  control,
  materialType,
  customerType,
  selectCustomerType,
  setSelectCustomerType,
  customer,
  selectCustomer,
  setSelectCustomer,
}) {
  const [editCustomer, setEditCustomer] = useState(false);
  const information = useSelector((state) => state.information);
  const {
    setting: { ims: imsSetting },
  } = information;

  const handlePushtoSelectCustomer = (select) => {
    const removeIndex = _.indexOf(selectCustomer, select);
    if (removeIndex > -1) {
      const newArr = _.filter(
        selectCustomer,
        (_customer, index) => index !== removeIndex,
      );
      setSelectCustomer(newArr);
    } else {
      setSelectCustomer([...selectCustomer, select]);
    }
  };

  return (
    <div className="flex flex-row flex-wrap w-full">
      <div className="font-semibold">ข้อมูลสินค้า</div>
      {/* {imsSetting?.attribute?.type_code && ( */}
      <div className="w-full px-1 py-2"></div>
      {/* )} */}
      <div className="w-full lg:w-1/2 px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={material ? material.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อสินค้า"
              fullWidth
              size={'small'}
              required
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      {Object.entries(Place).map(([key, place], idx) => {
        return (
          <Controller
            key={key}
            name={`place.${key}.status`}
            control={control}
            defaultValue={material?.place?.name === key}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={place.description}
              />
            )}
          />
        );
      })}
      <div className="w-full px-1 py-2">
        {!_.isEmpty(materialType?.rows) && (
          <Controller
            name={'material_type'}
            control={control}
            defaultValue={material ? material?.material_type : null}
            rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                defaultValue={field.value}
                options={materialType?.rows}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => {
                  field.onChange(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    label="ประเภทสินค้า"
                    inputProps={{
                      ...params.inputProps,
                    }}
                    helperText={
                      errors.material_type && 'กรุณาใส่ข้อมูลประเภทสินค้า'
                    }
                  />
                )}
              />
            )}
          />
        )}
      </div>
      {/* 
      <div className="w-full lg:w-1/2 px-1 py-2">
        <Controller
          name={'minimum_amount'}
          control={control}
          defaultValue={material ? material.minimum_amount : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="จำนวนขั้นต่ำของสินค้า"
              fullWidth
              type="number"
              size={'small'}
              helperText={errors.minimum_amount && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div> */}
      {/* <div className="w-full lg:w-1/2 px-1 py-2">
        <Controller
          name={'maximum_amount'}
          control={control}
          defaultValue={material ? material.maximum_amount : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="จำนวนขั้นสูงสุดของสินค้า"
              fullWidth
              type="number"
              size={'small'}
              helperText={errors.maximum_amount && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div> */}

      <div className="w-full px-1 py-2">
        <Controller
          name={'detail'}
          control={control}
          defaultValue={material ? material.detail : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              rows={2}
              multiline={true}
              size={'small'}
              helperText={errors.detail && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
    </div>
  );
}

EditMaterialForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    unit: PropTypes.object,
    net: PropTypes.object,
    unit_net: PropTypes.object,
    detail: PropTypes.object,
    type_code: PropTypes.object,
    minimum_amount: PropTypes.object,
    register_number: PropTypes.object,
  }),
  material: PropTypes.object,
  materialType: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
  customerType: PropTypes.object,
  selectCustomerType: PropTypes.object,
  setSelectCustomerType: PropTypes.object,
  customer: PropTypes.object,
  selectCustomer: PropTypes.object,
  setSelectCustomer: PropTypes.object,
};

EditMaterialForm.defaultProps = {
  material: null,
  materialType: null,
  customerType: null,
};

export default EditMaterialForm;
